import { h } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";
import Uploader from "../Uploader";

export default function DataroomFilesUploadDialog(props) {
    console.log("DataroomFilesUploadDialog", props);

    const handleClose = () => {
        props.onClose();
    };
    const [state, setState] = useState({ init: false, target_uid: props.state.params.catUid, popup_params: props.state.params.popup_params });

    useEffect(() => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({
                target_uid: props.state.params.catUid,
                session_uid: state.session_uid
            }),
        };
        fetch("/upload/e48dcaabe83040548c5291e9d3b9d716/docs", requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        //reset
                        setState({ ...state, has_session_id: true, session_uid: res.pld })

                        break;

                    case "err":
                        break;
                    default:
                        break;
                }
            });

    }, []);

    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog">
                <Typography variant="h5">Envoyer un fichier</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Uploader mode="docs" upperState={state} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    );
}
